import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
// import { getbase64 } from '@/utils/base64Converter';
import { useFormik } from 'formik';
import {
  EditCategoryDetail,
  UploadCategoryImage,
} from '../../../redux/admin/category/category_services_syn';
import { getbase64 } from '../../../utils/base64Converter';
import { updateCategoryImageDetails } from '../../../redux/admin/category/category_slices';
import { InfinitySpin } from 'react-loader-spinner';

const baseSchema = Yup.object({
  name: Yup.string().required(),
  slug: Yup.string(),
  description: Yup.string(),
});

const Edit_Category = () => {
  const dispatch = useDispatch();

  const [image, setImage] = useState();

  const {
    categoryEditLoader,
    categoryImageDetails,
    catEditLoader,
    categoryDetails,
  } = useSelector((state) => state.category);

  const handleSubmited = async (value, { resetForm }) => {
    // e.preventDefault();

    if (catEditLoader) return;

    const payload = {
      ...value,
      category_image: categoryImageDetails?.secure_url,
      category_image_id: categoryImageDetails?.public_id,
    };

    await dispatch(EditCategoryDetail({ ...categoryDetails, ...payload }));

    resetForm();

    // router.push('/admin_dashboard/users');
  };

  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    errors,
    setFieldValue,
  } = useFormik({
    initialValues: {
      name: '',
      slug: '',
      description: '',
    },
    validationSchema: baseSchema,
    onSubmit: handleSubmited,
  });

  const handleCategoryImage = (e) => {
    if (categoryEditLoader) return;

    const image = e.target.files[0];

    if (image) {
      let promise = getbase64(image);
      promise
        .then((data) => {
          dispatch(UploadCategoryImage({ file: data }));
          return data;
        })
        .then((res) => {
          setImage(image?.name);
        });
    }
  };

  useEffect(() => {
    setFieldValue('name', categoryDetails?.name);

    setFieldValue('slug', categoryDetails?.slug);

    setFieldValue('description', categoryDetails?.description);

    setImage(categoryDetails?.category_image);

    dispatch(
      updateCategoryImageDetails({
        secure_url: categoryDetails?.category_image,
        public_id: categoryDetails?.category_image_id,
      })
    );
  }, [categoryDetails]);

  return (
    <>
      <div class="row">
        <div class="col-xl-3 col-lg-4">
          <div class="card">
            <div class="card-body">
              <div class="bg-light text-center rounded bg-light">
                {categoryImageDetails?.secure_url && (
                  <img
                    src={categoryImageDetails?.secure_url}
                    alt=""
                    class="avatar-xxl"
                  />
                )}
              </div>
              <div class="mt-3">
                <h4>{image ? image : <>Category pics</>}</h4>
              </div>
            </div>
            <div class="card-footer border-top">
              <div class="row g-2">
                <div class="col-lg-6">
                  <a href="#!" class="btn btn-primary w-100">
                    Cancel
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-9 col-lg-8 ">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Add Thumbnail Photo</h4>
            </div>
            <div class="card-body">
              <form
                action="https://techzaa.in/"
                method="post"
                class="dropzone"
                id="myAwesomeDropzone"
                data-plugin="dropzone"
                data-previews-container="#file-previews"
                data-upload-preview-template="#uploadPreviewTemplate"
                style={{ position: 'relative' }}
              >
                <div class="fallback">
                  <input
                    name="file"
                    type="file"
                    multiple
                    onChange={handleCategoryImage}
                    style={{
                      border: '1px solid red',
                      position: 'absolute',
                      width: '98%',
                      height: '90%',
                      opacity: 0,
                    }}
                  />
                </div>
                <div class="dz-message needsclick">
                  <i class="bx bx-cloud-upload fs-48 text-primary"></i>
                  <h3 class="mt-4">
                    Drop your images here, or{' '}
                    <span class="text-primary">click to browse</span>
                  </h3>
                  <span class="text-muted fs-13">
                    {image ? (
                      `${image}`
                    ) : (
                      <>
                        1600 x 1200 (4:3) recommended. PNG, JPG and GIF files
                        are allowed
                      </>
                    )}
                  </span>
                </div>
              </form>
            </div>

            {categoryEditLoader && (
              <div class="form-group col-sm-9">
                <InfinitySpin width="100" color="#FE6B30" />
              </div>
            )}
          </div>
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">General Information</h4>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-lg-6">
                  <form>
                    <div class="mb-3">
                      <label for="category-title" class="form-label">
                        Category Title
                      </label>
                      <input
                        type="text"
                        id="category-title"
                        class="form-control"
                        placeholder="Enter Name"
                        value={values.name || ''}
                        onChange={handleChange}
                        name="name"
                        style={{
                          border: errors.name && '1px solid red',
                        }}
                      />
                    </div>
                  </form>
                </div>

                <div class="col-lg-6">
                  <form>
                    <div class="mb-3">
                      <label for="product-id" class="form-label">
                        Slug
                      </label>
                      <input
                        type="text"
                        id="slug"
                        class="form-control"
                        placeholder="Category Slug"
                        value={values.slug || ''}
                        onChange={handleChange}
                        name="slug"
                        style={{
                          border: errors.slug && '1px solid red',
                        }}
                      />
                    </div>
                  </form>
                </div>

                <div class="col-lg-12">
                  <div class="mb-0">
                    <label for="description" class="form-label">
                      Description
                    </label>
                    <textarea
                      class="form-control bg-light-subtle"
                      id="description"
                      rows="7"
                      placeholder="Type description"
                      value={values.description || ''}
                      onChange={(e) => {
                        if (e.target.value.length <= 60) {
                          handleChange(e);
                        }
                      }}
                      name="description"
                      maxLength={60}
                      style={{
                        border: errors.description && '1px solid red',
                      }}
                    ></textarea>
                    <small>
                      {values.description?.length || 0}/60 characters
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-3 bg-light mb-3 rounded">
            <div class="row justify-content-end g-2">
              <div class="col-lg-2">
                <a class="btn btn-primary w-100" onClick={handleSubmit}>
                  {catEditLoader ? (
                    <div class="form-group col-sm-9">
                      <InfinitySpin width="100" color="#FE6B30" />
                    </div>
                  ) : (
                    <>Update Category</>
                  )}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Edit_Category;
